import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  Redirect,
  Route,
  Switch,
} from 'react-router-dom';

import CaseMenu from './containers/CaseMenu/CaseMenu';
import FlexContainer from '@components/FlexContainer/FlexContainer';

import Claims from '@routes/Case/Claims/Claims';
import CaseDetails from '@routes/Case/Details/CaseDetails';
import CaseDockets from '@routes/Case/Dockets/CaseDockets';
import Inquiry from '@routes/Case/Inquiry/Inquiry';

import { getCaseDetails } from '@actions/caseDetails';

import './Case.scss';

class Case extends React.Component {
  componentDidMount() {
    const {
      fetchCaseDetails,
      match: { params: { id } },
      history: { replace },
    } = this.props;

    if (!Number(id)) {
      replace('/cases');
    } else {
      fetchCaseDetails(id);
    }
  }

  render() {
    const {
      location: { pathname },
      match: { params: { id } },
    } = this.props;

    return (
      <FlexContainer>
        <div className="case__menu">
          <CaseMenu
            isInquiry={pathname.includes('/inquiry')}
            caseId={id}
          />
        </div>
        <Switch>
          <Route path="/cases/:id/details" component={CaseDetails} />
          <Route path="/cases/:id/claims" component={Claims} />
          <Route path="/cases/:id/dockets" component={CaseDockets} />
          <Route path="/cases/:id/inquiry" component={Inquiry} />
          <Redirect from="/cases/:id" to="/cases/:id/details" />
        </Switch>
      </FlexContainer>
    );
  }
}

Case.propTypes = {
  fetchCaseDetails: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

const mapStateToProps = () => ({});

const mapDispatchToProps = dispatch => bindActionCreators({
  fetchCaseDetails: getCaseDetails,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(Case);



// WEBPACK FOOTER //
// ./src/routes/Case/Case.js